import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { TranslocoLocaleModule } from '@ngneat/transloco-locale';
import { EmailClipModule } from '@platform-frontend/account-ui';
import { CheckoutModule, DrawDialogModule, ShoppingCartConfiguratorModule } from '@platform-frontend/checkout';
import { MarketplaceAssetModule, MarketplaceProductModule } from '@platform-frontend/marketplace';
import { PollingModule } from '@platform-frontend/platform';
import {
  ButtonModule,
  CommonWordingModule,
  FormsModule,
  icoCalendarDuo,
  icoAddProductDuo,
  icoLocationPinDuo,
  icoLocationStartDuo,
  icoUserGroupDuo,
  IconsModule,
  LinkModule,
  LoadingIndicatorModule,
  StatusTagModule,
  TabSelectableModule,
  TemplateVariablesModule,
  TooltipModule
} from '@platform-frontend/ui-tools';
import { RouterExtensionsModule } from '@platform-frontend/util';
import { MatomoTrackClickDirective } from 'ngx-matomo-client';
import { TranslocoMarkupModule } from 'ngx-transloco-markup';
import { HeaderModule } from '../header/header.module';
import { AddPaymentMethodCommonComponent } from './add-payment-method-common/add-payment-method-common.component';
import { BillingAddressSelectionCommonComponent } from './billing-address-selection-common/billing-address-selection-common.component';
import { CommercialHeaderTravelTicketDescriptionComponent } from './commercial-header-travel-ticket-description/commercial-header-travel-ticket-description.component';
import { CommercialHeaderComponent } from './commercial-header/commercial-header.component';
import { PaymentMethodSelectionCommonComponent } from './payment-method-selection-common/payment-method-selection-common.component';
import { PaymentMethodWithDataComponent } from './payment-method-with-data/payment-method-with-data.component';
import { PaymentMethodWithPollingComponent } from './payment-method-with-polling/payment-method-with-polling.component';
import { ScaAuthenticationComponent } from './sca-authentication/sca-authentication.component';
import { ScaSpinnerComponent } from './sca-spinner/sca-spinner.component';
import { SolutionDownloadComponent } from './solution-download/solution-download.component';

@NgModule({
  declarations: [
    AddPaymentMethodCommonComponent,
    BillingAddressSelectionCommonComponent,
    CommercialHeaderComponent,
    CommercialHeaderTravelTicketDescriptionComponent,
    PaymentMethodSelectionCommonComponent,
    PaymentMethodWithDataComponent,
    PaymentMethodWithPollingComponent,
    ScaAuthenticationComponent,
    ScaSpinnerComponent,
    SolutionDownloadComponent
  ],
  exports: [
    AddPaymentMethodCommonComponent,
    BillingAddressSelectionCommonComponent,
    CommercialHeaderComponent,
    CommercialHeaderTravelTicketDescriptionComponent,
    PaymentMethodSelectionCommonComponent,
    PaymentMethodWithDataComponent,
    PaymentMethodWithPollingComponent,
    ScaAuthenticationComponent,
    SolutionDownloadComponent
  ],
  imports: [
    ButtonModule,
    CheckoutModule,
    CommonModule,
    CommonWordingModule,
    EmailClipModule,
    FormsModule,
    HeaderModule,
    IconsModule.withIcons(icoLocationStartDuo, icoLocationPinDuo, icoCalendarDuo, icoAddProductDuo, icoUserGroupDuo),
    LinkModule,
    LoadingIndicatorModule,
    MatomoTrackClickDirective,
    MarketplaceAssetModule,
    DrawDialogModule,
    MarketplaceProductModule,
    PollingModule,
    ReactiveFormsModule,
    RouterExtensionsModule,
    RouterModule,
    ShoppingCartConfiguratorModule,
    StatusTagModule,
    TabSelectableModule,
    TemplateVariablesModule,
    TooltipModule,
    TranslocoLocaleModule,
    TranslocoMarkupModule,
    TranslocoModule
  ]
})
export class CommercialCommonModule {}
